import type { CatalogTree } from '../types';

// The support session: Destek görünümü aç, the banner of §4.1 and the support views of §3.4
// (admin panel screens).
export const support = {
  open: {
    label: 'Destek görünümü aç',
    reason: 'Gerekçe',
    description: 'Bu oturumdaki her okuma denetim kaydına yazılır ve 60 dakika sonra sona erer.',
    submit: 'Oturumu aç',
  },
  banner: {
    active: 'Destek oturumu açık · Gerekçe: {reason} · {remaining}',
    closing: 'Destek oturumu açık · Gerekçe: {reason} · Oturum {n} dk içinde sona erecek',
    end: 'Oturumu bitir',
  },
  ended: 'Destek oturumu sona erdi.',
  again: 'Yeni oturum aç',
  title: 'Destek görünümü · {name}',
  notice: 'Bu görünüm salt okunurdur. Her sayfa ve her konuşma açılışı denetim kaydına yazılır.',
  refresh: 'Yenile',
  filters: { status: 'Durum', flavor: 'Kanal', search: 'Ara' },
  listLabel: 'Konuşmalar',
  empty: 'Bu filtreye uyan konuşma yok.',
  unread: 'Okunmadı',
  transcriptLabel: 'Mesajlar',
} as const satisfies CatalogTree;
